import { CatalogTableColumnsFunc, CatalogTableRow, CatalogTable } from '@backstage/plugin-catalog'; 
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';
import { Typography } from '@material-ui/core';

import { EntityListContextProps } from '@backstage/plugin-catalog-react';

export const healthStatusCatalogTableColumnsFunc: CatalogTableColumnsFunc = (context: EntityListContextProps) => {
  const defaultColumns = CatalogTable.defaultColumnsFunc(context);

  // Only add healthStatus column if kind filter is 'Component'
  if (context.filters.kind?.value?.toLowerCase() !== 'component') {
    return defaultColumns;
  }

  return [
    ...defaultColumns,
    {
      title: 'Health Status',
      field: 'metadata.annotations.healthStatus',
      sorting: true,
      type: 'string',
      customSort: (a: CatalogTableRow, b: CatalogTableRow) => {
        const aStatus = a.entity.metadata.annotations?.healthStatus?.toLowerCase() ?? '';
        const bStatus = b.entity.metadata.annotations?.healthStatus?.toLowerCase() ?? '';
        return aStatus.localeCompare(bStatus);
      },
      render: (row: CatalogTableRow) => {
        const status = row.entity.metadata.annotations?.healthStatus ?? 'unknown';
        let icon;
        let color;
        switch (status.toLowerCase()) {
          case 'healthy':
            icon = <CheckCircleIcon style={{ color: 'green' }} />;
            color = 'green';
            break;
          case 'degraded':
            icon = <WarningIcon style={{ color: 'orange' }} />;
            color = 'orange';
            break;
          case 'unhealthy':
            icon = <ErrorIcon style={{ color: 'red' }} />;
            color = 'red';
            break;
          default: // 'unknown'
            icon = <WarningIcon style={{ color: 'gray' }} />;
            color = 'gray';
        }
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {icon}
            <Typography style={{ marginLeft: 8, color }}>{status}</Typography>
          </div>
        );
      },
    },
  ];
};
